/**
 * Pages that run as a frame inside another product (Outreach tiles and tabs,
 * the HubSpot LinkedIn modal). They have no app chrome, are always light, and
 * must never be redirected to the dashboard or login.
 */
const EMBEDDED_PREFIXES = ["/outreach/", "/hubspot/"];

export const isEmbeddedPath = (pathname: string) => EMBEDDED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
